const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
export const IS_T3_WEBSITE = new URLSearchParams(locationSearch).has('isdealer');
export const IS_MOCK = !!new URLSearchParams(locationSearch).has('mock');
